import React from "react";
import Modal from "src/components/ui/Modal";
import Button from "src/components/ui/Button";
import { SUPPORT_CONTACT } from "src/constants/supportContact";

interface ContactSupportModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
}

const ContactSupportModal: React.FC<ContactSupportModalProps> = ({
  open,
  onClose,
  title = "Contact Support",
}) => {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      <div className="space-y-4">
        <div className="space-y-2 text-sm text-gray-700">
          <p>Please reach out to support for plan renewal.</p>
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
            <p className="font-medium text-gray-900">Email</p>
            <a
              href={`mailto:${SUPPORT_CONTACT.email}`}
              className="text-primary-600 hover:underline"
            >
              {SUPPORT_CONTACT.email}
            </a>
          </div>
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
            <p className="font-medium text-gray-900">Phone</p>
            <a
              href={`tel:${SUPPORT_CONTACT.phone}`}
              className="text-primary-600 hover:underline"
            >
              {SUPPORT_CONTACT.phone}
            </a>
          </div>
        </div>
        <div className="flex justify-end">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ContactSupportModal;
